import { render } from "./profileComponent.vue?vue&type=template&id=3643e58a&scoped=true"
import script from "./profileComponent.vue?vue&type=script&lang=js"
export * from "./profileComponent.vue?vue&type=script&lang=js"

import "./profileComponent.vue?vue&type=style&index=0&id=3643e58a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3643e58a"]])

export default __exports__